import axios from 'axios';
import React, { useEffect, useState } from 'react'
import apiClient from '../../../utils/apiclient';
import { useNavigate } from 'react-router-dom';
import ReactSearchBox from "react-search-box";

const AllUsers = (route) => {
  const [data, setData] = useState([]);
const [search, Setsearch] = useState("");
const [isloading, SetIsLoading] = useState(false);

const [page, setPage] = useState(0);
const [size] = useState(20);
const [totalPages, setTotalPages] = useState(0);
const navigate = useNavigate()
useEffect(() => {
  fetchUsers(search);
}, [route.route, page, search]);

const fetchUsers = async (number = "") => {
  try {
    SetIsLoading(true);

    const response = await apiClient.get(
      `${route.route}?page=${page}&size=${size}&search=${number}`
    );

    setData(response.data.content);
    setTotalPages(response.data.totalPages);
  } catch (e) {
    console.error(e);
  } finally {
    SetIsLoading(false);
  }
};
  const filteredData = Array.isArray(data)
  ? data.filter((el) => {
      if (search.trim() === "") return true;

      return (
        el.name?.toLowerCase().includes(search.toLowerCase()) ||
        el.number?.toString().includes(search) ||
        el.email?.toLowerCase().includes(search.toLowerCase())||
        el.id?.toString().includes(search)
      );
    })
  : [];
  console.log("API data", data);
console.log("Filtered data", filteredData);
 const handlechange = (e) => {
  const value = e.target.value;
  Setsearch(value);
};
  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">
          {route.route === "/AllChef" ? "All Chefs" : "All Users"}
        </h2>
        <input className="flex-1 border-2 py-1.5 px-3 md:py-2 md:px-4 text-sm md:text-base rounded-lg outline-none focus:border-blue-500 min-w-0"
          placeholder='Search...'
          onChange={handlechange}
          value={search}
        />
      </div>
     <div className="w-full flex-1 flex flex-col min-h-0">

  {isloading && (
    <div className="absolute inset-0 bg-white/70 flex justify-center items-center z-10">
      <div className="text-lg font-semibold">
        Loading...
      </div>
    </div>
  )}
<div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
  <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
      <tr>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">
          Customer Id
        </th>

        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm" >name</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">number</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">email</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">city</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">street</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">latitude</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">longitude</th>
       

      </tr>
      </thead>
      <tbody>
        {isloading?"Loading...":(
          filteredData.map((data,index)=>(
        
            <tr key={index} className='items-center justify-center border border-gray-300'>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.id}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.name}</td>
              
              
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:cursor-pointer hover:underline" onClick={()=>{navigate(`/userDetails/${data.number}`)}}>{data.number}</td>
                              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.email}</td>
                              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.city}</td>
                              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.street}</td>
                              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.latitude}</td>
                              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.longitude}</td>

              </tr>
          ))
  )}
        </tbody>
     </table>
      </div> </div><div className="flex justify-center items-center gap-4 mt-4">

  <div className="flex justify-center items-center gap-4 mt-0 pb-4 flex-shrink-0">
        <button
          disabled={page === 0 || isloading}
          onClick={() => setPage((prev) => prev - 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Previous
        </button>

        <span className="font-medium text-gray-700">
          Page {page + 1} of {totalPages}
        </span>

        <button
          disabled={page >= totalPages - 1 || isloading}
          onClick={() => setPage((prev) => prev + 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Next
        </button>
      </div>

</div> 
   </div> );
};

export default AllUsers;